module.exports = __webpack_public_path__ + "static/media/dev-exam.969e46f1.png";